<template>
  <div>
    <el-row>
      <el-col :span="12">
        <el-input v-model="searchName" placeholder="请输入直播课堂名称" />
      </el-col>
      <el-col :span="3">
        <el-button type="primary" @click="getOnlineCourseList">搜索</el-button>
      </el-col>
    </el-row>

    <el-table
      ref="multipleTable"
      :data="tableData"
      :row-key="rowKey"
      style="width: 100%"
    >
      <el-table-column
        type="selection"
        :reserve-selection="true"
        width="55"
      ></el-table-column>
      <el-table-column prop="videoTitle" label="直播课堂名称">
      </el-table-column>
      <el-table-column prop="teacherName" label="主讲人"> </el-table-column>
      <el-table-column
        prop="starttime"
        label="上架时间"
        :formatter="formatDate"
      >
      </el-table-column>
      <el-table-column prop="endtime" label="下架时间" :formatter="formatDate">
      </el-table-column>
      <el-table-column prop="maxmannums" label="最大并发量"> </el-table-column>
    </el-table>
  </div>
</template>

<script>
import * as api from '@/api/courseStructure/courseStructure'
export default {
  props: ['userType', 'mhmId', 'zyVideoSectionId'],
  data() {
    return {
      searchName: '',
      tableData: [],
      pageObj: {
        page: 1,
        pageSize: 1000,
      },
      total: 0,
      rowKeyIndex: 0,
    }
  },
  created() {
    this.getOnlineCourseList()
  },
  computed: {
    getUId() {
      return localStorage.getItem('uid') 
    },
  },
  methods: {
    // 时间戳转日期
    formatDate(row, column, cellValue, index) {
      if (cellValue == null || cellValue == '') return ''
      let date = new Date(parseInt(cellValue) * 1000) //时间戳为10位需*1000，如果为13位的话不需乘1000。
      let Y = date.getFullYear() + '-'
      let M =
        date.getMonth() + 1 < 10
          ? '0' + (date.getMonth() + 1) + '-'
          : date.getMonth() + 1 + '-'
      let D =
        date.getDate() < 10 ? '0' + date.getDate() + ' ' : date.getDate() + ' '
      let h =
        date.getHours() < 10
          ? '0' + date.getHours() + ':'
          : date.getHours() + ':'
      let m =
        date.getMinutes() < 10
          ? '0' + date.getMinutes() + ':'
          : date.getMinutes() + ':'
      let s =
        date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
      return Y + M + D + h + m + s
    },
    getOnlineCourseList() {
      const { page, pageSize } = this.pageObj
      api
        .getZyVideoList({
          mhmId: this.mhmId,
          userType: this.userType,
          uid: this.getUId,
          page,
          pageSize,
          zyVideoSectionId: this.zyVideoSectionId,
          name: this.searchName,
        })
        .then(({ data }) => {
          if (data.code == 100000) {
            this.tableData = data.data
            const index = this.tableData.findIndex(
              (item) => item.checked === '1'
            )
            if (index > -1) {
              this.$refs.multipleTable.toggleRowSelection(
                this.tableData[index],
                true
              )
            }
          } else {
            this.$message({ type: 'error', message: data.msg })
          }
        })
    },
    save() {
      const selectedList = this.$refs.multipleTable.selection
      if (selectedList.length === 0) {
        return this.$message({
          type: 'warning',
          message: '请先选择需要操作的数据',
        })
      } else if (selectedList.length > 1) {
        return this.$message({ type: 'warning', message: '最多可选一门课' })
      } else {
        this.$parent.$parent.submitForm(selectedList[0].id)
      }
    },
    rowKey(row) {
      //返回值没有唯一值作为key
      const index = this.tableData.findIndex((item) => item === row)
      return row.id + row.videoTitle + index
    },
  },
}
</script>

<style>
</style>